import { useTranslation } from "next-i18next";
import { useSelector } from "react-redux";
import { RootState } from "../redux/store";
import { useFilters } from "../hooks/global/useFilters";
import { MaterialLayout } from "../components/global/layout/material/MaterialLayout";
import Head from "next/head";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { ExploreCoachesSection } from "../components/explore/material/exploreCoachesSection/ExploreCoachesSection";
import { Stack, Typography } from "@mui/material";
import { IGetStaticProps } from "../interfaces/next/IGetStaticProps";

export default function Specialists() {
  const { t } = useTranslation();
  const componentColors = useSelector(
    (state: RootState) => state.theme.componentColors
  );

  useFilters();

  return (
    <MaterialLayout>
      <Head>
        <title>{t("specialists")}</title>
        <meta name="dc.title" content={t("specialists")} />
        <meta name="og:title" content={t("specialists")} />
        <meta name="twitter:title" content={t("specialists")} />
      </Head>

      <Stack className="px-2 space-y-4 lg:space-y-6 min-h-[80vh]">
        <Typography
          variant="h1"
          className="text-lg lg:text-2xl "
          sx={{
            color: componentColors.surface.onSurface,
          }}
        >
          Coaches
        </Typography>

        <ExploreCoachesSection />
      </Stack>
    </MaterialLayout>
  );
}

export async function getStaticProps({
  locale,
}: {
  locale: string;
}): Promise<IGetStaticProps> {
  return {
    props: {
      ...(await serverSideTranslations(locale, [
        "common",
        "menu",
        "footer",
        "specialists",
      ])),
    },
  };
}
